import { createRoot, hydrateRoot } from "react-dom/client";
import { Router } from "wouter";
import App from "./App";
import "./index.css";

const base = import.meta.env.BASE_URL.replace(/\/$/, "");
const container = document.getElementById("root")!;

const tree = (
  <Router base={base}>
    <App />
  </Router>
);

// Only hydrate when there is actual prerendered element content.
// In dev (and freshly-built but not-yet-prerendered HTML), the root contains
// only the `<!--app-html-->` comment placeholder, which would otherwise cause
// hydrateRoot() to mismatch.
const hasPrerenderedContent = Array.from(container.childNodes).some(
  (n) => n.nodeType === Node.ELEMENT_NODE,
);

if (hasPrerenderedContent) {
  hydrateRoot(container, tree);
} else {
  // Strip the comment placeholder so React starts from a clean container.
  container.innerHTML = "";
  createRoot(container).render(tree);
}
